<template>
    <div>
        <div v-if="!loaded">
            <div class="panel text-center"><span
                class="loading-spinner loading-spinner-big loading-spinner-green"
                style="margin: 10rem 0;"></span>
            </div>
        </div>
        <div v-if="error">
            <div class="panel  no-sponsor-panel">
                <div class="panel-body pool-panel">
                    <p class="text-center">
                        Beim Laden des Sponsors ist ein Fehler aufgetreten. Du kannst
                        momentan
                        nur ungesponsert coden. Falls du später noch auf die gesponserte
                        Variante
                        wechseln möchtest, kontaktiere uns einfach. Zum Beispiel hier:
                        <a href="mailto:hallo@entwicklerheld.de">hallo@entwicklerheld.de</a>
                    </p>
                </div>
            </div>
        </div>
        <router-link
            v-if="loaded && !error"
            :to="{ name: 'company-profile', params: { slug: sponsoringRequest.apiData.companySlug }}"
            class="company-link">
            <div class="panel panel-clickable">
                <div class="panel-heading sponsored-panel-heading">
                    <h4 class="current-company-name text-center">
                        Gesponsert durch <strong>
                        {{ sponsoringRequest.apiData.name }}</strong>
                    </h4>
                    <div class="img-container">
                        <img class="company-hero-image" :src="sponsoredCompanyHeroImage"
                             :alt="'Hero Image of ' + sponsoringRequest.apiData.name ">
                        <div class="header-img-background" :style="sponsoredCompanyHeroImageBackgroundStyle"></div>
                    </div>
                    <div class="company-logo-wrapper">
                        <img
                            :alt="'This challenge is sponsored by '+sponsoringRequest.apiData.name"
                            :src=" sponsoringRequest.apiData.logo"
                            class="img-responsive company-logo"/>
                    </div>
                </div>
                <div class="panel-content sponsored-panel-content">
                    <div class="company-locations-wrapper">
                      <span v-if="sponsoredCompanyFullyRemote"
                            class="label remote-label tooltip-hover"
                            title="100% Remote-Arbeit möglich" data-toggle="tooltip"><i
                          class="dev-laptop"></i>
                        Remote
                      </span>
                        <i class="dev-map-pin" v-if="sponsoredCompanyLocations.length"></i>
                        <template v-for="(location, index) in sponsoredCompanyLocations">
                            <span class="company-location" :key="'loc' + index">{{ location.city }}</span>
                        </template>

                    </div>
                    <div class="company-slogan" v-html="sponsoredCompanySlogan"></div>
                    <div class="technology-labels">
                  <span class="company-technologies-wrapper"
                        v-for="(technology, index) in sponsoredCompanyTechnologies"
                        :key="technology.id">
                      <div class="company-technologies" v-if="index <= 2"
                           :class="{
                          'bg-python': technology.language.toLocaleLowerCase() === 'python',
                          'bg-java': technology.language.toLocaleLowerCase() === 'java',
                          'bg-dockerfile': technology.language.toLocaleLowerCase() === 'dockerfile',
                          'bg-javascript': technology.language.toLocaleLowerCase() === 'javascript',
                          'bg-csharp': technology.language.toLocaleLowerCase() === 'c#',
                          'bg-cpp': technology.language.toLocaleLowerCase() === 'c++',
                          'bg-php': technology.language.toLocaleLowerCase() === 'php',
                          'bg-abap': technology.language.toLocaleLowerCase() === 'abap',
                          'bg-kotlin': technology.language.toLocaleLowerCase() === 'kotlin',
                          'bg-powershell': technology.language.toLocaleLowerCase() === 'powershell',
                          'bg-rust': technology.language.toLocaleLowerCase() === 'rust',
                      }">
                          <i class="dev-icon dev-code-slash"></i>
                          <span class="technology">{{
                                  technology.label.toUpperCase()
                              }}
                          </span>
                      </div>
                  </span>
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import {services} from "../../main";

export default {
    name: "SponsoringDetails",
    props: {
        sponsoringRequest: {
            type: Object,
            required: true
        },
    },
    data: function () {
        return {
            companyProfileRequest: {
                loaded: false,
                error: false,
                apiData: {}
            }
        }
    },
    created() {
        if (this.sponsoringRequest.loaded) {
            this.loadCompanyProfile();
        }
    },
    computed: {
        loaded: function () {
            return this.sponsoringRequest.loaded && this.companyProfileRequest.loaded;
        },
        error: function () {
            return this.sponsoringRequest.error || this.companyProfileRequest.error;
        },
        sponsoredCompanyHeroImage: function () {
            if (this.companyProfileRequest.loaded && !this.companyProfileRequest.error) {
                if (this.companyProfileRequest.apiData.profile.heroImage === "" || this.companyProfileRequest.apiData.profile.heroImage === undefined) {
                    return "https://res.cloudinary.com/dspi5zyaa/image/upload/eh-platform/company_static/company-list-header_default.jpg"
                }
                return this.companyProfileRequest.apiData.profile.heroImage;
            }
        },
        sponsoredCompanyLocations: function () {
            if (this.companyProfileRequest.loaded && !this.companyProfileRequest.error) {
                if (this.companyProfileRequest.apiData.locations.length > 0) {
                    return this.companyProfileRequest.apiData.locations;
                }
                return "";
            }
        },
        sponsoredCompanyFullyRemote: function () {
            if (this.companyProfileRequest.loaded && !this.companyProfileRequest.error) {
                return this.companyProfileRequest.apiData.profile.has100PercentRemoteOption;
            }
        },
        sponsoredCompanySlogan: function () {
            if (this.companyProfileRequest.loaded && !this.companyProfileRequest.error) {
                return this.companyProfileRequest.apiData.profile.slogan;
            }
            return "";
        },
        sponsoredCompanyTechnologies: function () {
            if (this.companyProfileRequest.loaded && !this.companyProfileRequest.error) {
                if (this.companyProfileRequest.apiData.technologies.length > 0) {
                    return this.companyProfileRequest.apiData.technologies;
                }
                return "";
            }
        },
        sponsoredCompanyHeroImageBackgroundStyle: function () {
            return {
                'background-image': 'url(' + this.sponsoredCompanyHeroImage + ')',
            }
        }
    },
    watch: {
        sponsoringInformationDetailsRequest: function () {
            if (this.sponsoringRequest.loaded && !this.sponsoringRequest.error) {
                this.loadCompanyProfile();
            }
        }
    },
    methods: {
        loadCompanyProfile: function () {
            this.companyProfileRequest = services.companyService.getCompanyProfile(this.sponsoringRequest.apiData.companySlug);
        }
    }
}
</script>

<style scoped>
.sponsored-panel-content {
    padding: 2rem 1.5rem 1.5rem 1.5rem;
}

.sponsored-panel-heading {
    padding: 0;
    position: relative;
    background: white;
    display: inline-block;
    width: 100%;
    border-radius: 10px 10px 0 0;
    margin-top: 1rem;
}

.current-company-name {
    color: #151515;
    font-weight: 500;
    padding: 1rem 1rem 1.5rem 1rem;
    margin: 0 0;
    font-size: 2rem;
}

.img-container {
    position: relative;
    height: 200px;
    overflow: hidden;
}

.header-img-background {
    z-index: 1;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    -moz-border-radius-topright: 15px;
    border-radius: 10px 10px 0 0;
    position: absolute;
    background-position: center;
    left: 0;
    top: 0;
    filter: blur(5px);
}

.company-logo-wrapper {
    position: absolute;
    left: 0;
    max-width: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3;
    margin-left: 2rem;
    background: white;
    border-radius: 10px;
    /* center*/
    top: 50%;
    transform: translateY(10%);
    min-height: 120px;
    box-shadow: 0 10px 30px rgb(50 50 93 / 10%), 0 5px 10px rgb(0 0 0 / 17%);
    padding: 5px;
    max-height: 120px;
}

.company-hero-image {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    width: 100%;
    height: 100%;
    padding: 0;
    object-fit: contain;
    z-index: 2;
    position: absolute;
}

.company-locations-wrapper {
    color: #4d4f69;
    line-height: 1.6;
    margin-bottom: 1rem;
}

.remote-label {
    background: linear-gradient(.306turn, #08AB99 3.84%, #0BC4A2 93.74%);
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 400;
    margin-right: 4px;
}

.company-location {
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 0;
    margin-top: 1.5rem;
}

.company-location::after {
    content: "|";
    display: inline-block;
    font-size: 13px;
    margin-left: 0.125rem;
    margin-right: 0.25rem;
}

.company-locations-wrapper .company-location:last-child::after {
    content: "";
    display: none;
}

.company-slogan {
    margin-bottom: 1rem;
}

.company-technologies-wrapper {
    position: relative;
    display: inline-block;
}

.company-technologies {
    font-family: "Source Code Pro", sans-serif;
    color: white;
    overflow: hidden;
    padding: 3px 20px;
    margin-bottom: 2px;
    border-radius: 100px;
    background-color: grey;
    margin-right: 1rem;
    line-height: 1.6;
}

.company-technologies > .dev-icon {
    position: absolute;
    bottom: -10%;
    left: -5%;
    font-size: 28px;
    color: rgba(255, 255, 255, 0.15);
}

.technology {
    font-size: 11px;
}
</style>
